// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fBge","badges":"styles_badges__3p-Le"};